import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dialog-modal',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.css']
})
export class DialogModalComponent implements OnInit {
  @Input() dialogType: any;
  @Output() btnAction: EventEmitter<any> = new EventEmitter();

  icon = 'loading'
  platform: any;
  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  async ngOnInit() {
    if (this.dialogType === 'update_warning') {
      this.icon = 'dialog-confirmation';
    } else if (this.dialogType === 'invalid_number' || this.dialogType === 'fetch_consent') {
      this.icon = 'dialog-error';
    } else if (this.dialogType === 'tick_both_tnc') {
      this.icon = 'icon-error';
    } else {
      this.icon = 'dialog-success';
    }
    setTimeout(() => {
      this.platform = localStorage.getItem('platform');
    }, 100);
  }

  doAction() {
    this.btnAction.emit();
  }

  close() {
    this.activeModal.close();
  }
}
